<svg width="48" height="56" viewBox="0 0 48 56" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_4119_2005)">
    <rect width="48" height="56" rx="6" fill="#F8F8F8" />
    <g filter="url(#filter0_dd_4119_2005)">
      <path
        d="M-2 60.5H40V21.2426C40 20.447 39.6839 19.6839 39.1213 19.1213L28.8787 8.87868C28.3161 8.31607 27.553 8 26.7574 8H-2V60.5Z"
        fill="white"
      />
    </g>
    <mask
      id="mask0_4119_2005"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="-2"
      y="8"
      width="42"
      height="53"
    >
      <path
        d="M1 60.5H37C38.6569 60.5 40 59.1569 40 57.5V18.2426C40 17.447 39.6839 16.6839 39.1213 16.1213L31.8787 8.87868C31.3161 8.31607 30.553 8 29.7574 8H1C-0.656854 8 -2 9.34315 -2 11V57.5C-2 59.1569 -0.656853 60.5 1 60.5Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4119_2005)">
      <path
        d="M28.8787 8.87868L39.1213 19.1213C39.6733 19.6733 39.9879 20.4181 39.9997 21.1974C39.9999 21.2071 40 21.2168 40 21.2265V21.2426C40 21.2276 39.9999 21.2125 39.9997 21.1974C39.9859 20.6105 39.557 20.1137 38.9751 20.0167C38.9085 20.0056 38.841 20 38.7735 20H28V9.22651C28 9.15895 27.9944 9.09151 27.9833 9.02487C27.8863 8.44304 27.3895 8.01408 26.8026 8.00034C26.7875 8.00011 26.7724 8 26.7574 8H26.7735C26.7832 8 26.7929 8.00011 26.8026 8.00034C27.5819 8.01207 28.3267 8.32673 28.8787 8.87868Z"
        fill="#E8E8E8"
      />
    </g>
    <rect x="8" y="29" width="24" height="2" rx="0.75" fill="#E8E8E8" />
    <rect x="8" y="34" width="24" height="2" rx="0.75" fill="#E8E8E8" />
    <rect x="8" y="39" width="24" height="2" rx="0.75" fill="#E8E8E8" />
    <rect x="8" y="44" width="15.75" height="2" rx="0.75" fill="#E8E8E8" />
  </g>
  <rect x="0.5" y="0.5" width="47" height="55" rx="5.5" stroke="#EBEBEB" />
  <defs>
    <filter
      id="filter0_dd_4119_2005"
      x="-34.625"
      y="-11.125"
      width="107.25"
      height="117.75"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="1.69041" />
      <feGaussianBlur stdDeviation="2.04258" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.045 0" />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4119_2005" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="13.5" />
      <feGaussianBlur stdDeviation="16.3125" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0" />
      <feBlend
        mode="normal"
        in2="effect1_dropShadow_4119_2005"
        result="effect2_dropShadow_4119_2005"
      />
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4119_2005" result="shape" />
    </filter>
    <clipPath id="clip0_4119_2005">
      <rect width="48" height="56" rx="6" fill="white" />
    </clipPath>
  </defs>
</svg>
